

import { ENV } from '../../config/runtimeEnv';
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;


// The RBAC catalogue's roles by group, for display and for classifying other accounts' records — never a UI gate (gates use session permissions).
// One role per line, single-quoted: tests/harness/scripts/role-catalogue-guard.sh diffs it against the admin export.
export const RoleGroups = {
	ADMINISTRATIVE: [
		'System Administration',
		'Organization Administrator',
		'Clinic Administrator',
		'Billing Administrator',
	],
	CLINICAL: [
		'Chief Medical Officer',
		'Practitioner',
		'Specialist Physician',
		'Nurse Practitioner',
		'Registered Nurse',
		'Medical Assistant',
		'Pharmacist',
		'Physical Therapist',
		'Occupational Therapist',
		'Speech Therapist',
		'Mental Health Provider',
		'Dietitian/Nutritionist',
	],
	SUPPORT: [
		'Medical Records Specialist',
		'Reception',
		'Billing Specialist',
		'Finance Manager',
		'IT Support',
		'IT Management',
		'User Management',
		'Inventory Management',
		'HI Reviewer',
	],
	PATIENT: [
		'Patient',
		'Guardian/Caregiver',
		'Patient Proxy',
		'Customer',
	],
	RESEARCH: [
		'Auditor',
	],
	LAB: [
		'Lab Management',
		'Laboratory Technician',
		'Pathologist',
		'Radiologist',
		'Geneticist',
	],
	// Product access held by patients AND staff — never a staff group, or every patient becomes lab staff.
	GENE_CODES: [
		'gene.codes',
	],
	LEGACY: [
		'admin',
		'User',
	],
};

export const getAllRoles = async () => {
    const response = await http.get(`${API_BASE_URL}/admin/roles`);
    return response.data;
};

export const getAllRolesPractitioner = async () => {
	const response = await http.get(`${API_BASE_URL}/practitioner/roles`);
	return response.data;
};


export const assignUserRolePractitioner = async (userId: UserUuid, role: string) => {
	const response = await http.post(`${API_BASE_URL}/practitioner/users/${userId}/assign-role`, { role });
	return response.data;
};

export const removeUserRolePractitioner = async (userId: UserUuid, role: string) => {
	const response = await http.post(`${API_BASE_URL}/practitioner/users/${userId}/remove-role`, { role });
	return response.data;
};